import { MyLevelDTO, UserDTO } from '@/models';
import { fetchCurrentUserData } from '@/services';

interface AppState {
  currentUser: UserDTO;
  userLevel: MyLevelDTO;
  isCurrentUserFetching: boolean;
  productTutorialDialogShown: boolean;
  newLevelDialogShown: boolean;
  isAssessmentPeriodJustCreated: boolean;
}

const initialState = {
  currentUser: {} as UserDTO,
  userLevel: null,
  isCurrentUserFetching: true,
  productTutorialDialogShown: false,
  newLevelDialogShown: false,
  isAssessmentPeriodJustCreated: false
};

const getters = {
  currentUser: (state: AppState): UserDTO => {
    return state.currentUser;
  },
  isCurrentUserFetching: (state: AppState): boolean => {
    return state.isCurrentUserFetching;
  },
  userLevel: (state: AppState): MyLevelDTO => {
    return state.userLevel;
  },
  productTutorialDialogShown: (state: AppState): boolean => {
    return state.productTutorialDialogShown;
  },
  newLevelDialogShown: (state: AppState): boolean => {
    return state.newLevelDialogShown;
  },
  isAssessmentPeriodJustCreated: (state: AppState): boolean => {
    return state.isAssessmentPeriodJustCreated;
  }
};

const mutations = {
  setCurrentUser: (state: AppState, currentUser: UserDTO): void => {
    state.currentUser = currentUser;
  },
  setIsCurrentUserFetching: (state: AppState, isCurrentUserFetching: boolean): void => {
    state.isCurrentUserFetching = isCurrentUserFetching;
  },
  setUserLevel: (state: AppState, MyLevelDTO: MyLevelDTO): void => {
    state.userLevel = MyLevelDTO;
  },
  setProductTutorialDialogShown: (state: AppState, productTutorialDialogShown: boolean): void => {
    state.productTutorialDialogShown = productTutorialDialogShown;
  },
  setNewLevelDialogShown: (state: AppState, newLevelDialogShown: boolean): void => {
    state.newLevelDialogShown = newLevelDialogShown;
  },
  setIsAssessmentPeriodJustCreated: (state: AppState, isAssessmentPeriodJustCreated: boolean): void => {
    state.isAssessmentPeriodJustCreated = isAssessmentPeriodJustCreated;
  }
};

const actions = {
  async fetchCurrentUser({ commit, state }: any): Promise<UserDTO> {
    if (state.currentUser.id) {
      return state.currentUser;
    }
    const { data } = await fetchCurrentUserData();
    commit('setCurrentUser', data);
    commit('setIsCurrentUserFetching', false);
    return data;
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
